export const formatWithWebp = (src) => {
  const inputSrc = src || '';
  const extensionReg = /\.(gif|jpg|jpeg|tiff|png)$/i;
  return inputSrc.replace(extensionReg, '.webp');
};

// export const testUrl = url => new Promise((resolve, reject) => {
//   const imgElement = new Image();
//   imgElement.addEventListener('load', () => resolve());
//   imgElement.addEventListener('error', () => reject());
//   imgElement.src = url;
// });
